import { ImportIcon } from './ImportIcon';

/**
 * author: Austin Andrews
 * id FB8BEE36-EF77-4820-92B3-5B4C4291D751
 * name import
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/import.svg
 * tags
 */
export const InputIcon = ImportIcon;
export default InputIcon